<template>
  <div class="pure-g text-center">
    <div class="pure-u-1">
      <Loading/>
    </div>
  </div>
</template>

<script>
  import store from '../../lib/store';
  import error from '../../lib/error';
  import subscription from '../../lib/subscription';
  import Loading from '../helpers/Loading';

  export default {
    name: 'Subscriber',
    components: { Loading },
    created() {
      /* global ga */
      ga('send', 'pageview', `/${store.get('subscription')}/Subscriber`);

      const succeeded = () => {
        this.$emit('success');
      };
      subscription.create('MailingList', store.get('mailing_list'), (err, res) => {
        if (err) {
          if (res && res.statusCode !== 422) {
            error.alert('Something went wrong, please try again');
          } else {
            succeeded();
          }
        } else {
          succeeded();
        }
      });
    },
  };
</script>



// WEBPACK FOOTER //
// Subscriber.vue?13b601fe